import { api } from '@web/api/client'
import type { DemoScenarios } from '@web/api/types'
import { useEffect, useState } from 'react'

/** Load scenarios from the exact installed package used by this session. */
export function useDemoScenarios(
  appId: string,
  packageDigest: string | null | undefined,
  enabled: boolean,
) {
  const [catalog, setCatalog] = useState<DemoScenarios | null>(null)
  const [error, setError] = useState('')
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let active = true
    setCatalog(null)
    setError('')
    if (enabled)
      void api.appScenarios(appId, packageDigest).then(
        (value) => {
          if (active) setCatalog(value)
        },
        (failure: Error) => {
          if (active) setError(failure.message)
        },
      )
    return () => {
      active = false
    }
  }, [appId, packageDigest, enabled, attempt])
  return { catalog, error, retry: () => setAttempt((value) => value + 1) }
}
